export enum RuleTargetTypes {
  none = 'none',
  extension = 'extension',
  external = 'external',
  service = 'service',
}
